// extracted by mini-css-extract-plugin
module.exports = {"container":"header-module--container--18lpt"};